import en from '../constants/en.json';
import es from '../constants/es.json';

const LANGS = { en, es };

export function getCurrentLang() {
  return (
    document.cookie.match(/(?:^|; )NEXT_LOCALE=([^;]*)/)?.[1] ||
    localStorage.getItem('lang') ||
    'en'
  );
}

export function t(key) {
  const lang = getCurrentLang();
  const dict = LANGS[lang] || LANGS.en;
  return key.split('.').reduce((o, i) => (o ? o[i] : undefined), dict) || key;
} 